import React, { useEffect } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './index.scss';

const BottomSectionAddressAOI = ({
  submitBtnName = 'Proceed',
  cancelBtnName = 'Cancel',
  onSubmitClick = () => {},
  onCancelClick = () => {},
  isSubmitDisabled = false,
  title = '',
  value = '',
  spaceBetween = false,
  loader = false
}) => {
  useEffect(() => {
    document.getElementById('root').className = 'multisite-pricing-strip';
    return () => {
      document.getElementById('root').classList.remove('multisite-pricing-strip');
    };
  }, []);

  return (
    <div className="bottom-section selected-plans active">
      <div className="container">
        <div className="inside-plan show_full_view">
          <div className="plan-info">
            <div className="plan_details_veiw">
              <div className="left_col">
                <h4>{title}</h4>
                <div class="value mt-10">{value}</div>
              </div>
            </div>
          </div>
          <div className={`plan-details ${spaceBetween ? 'justify-content-end' : ''}`}>
            <div className="action">
              <Button variant="outlinebtn" onClick={onCancelClick}>
                {cancelBtnName}
              </Button>
              <Button className="activebtn" disabled={isSubmitDisabled} onClick={onSubmitClick}>
                {submitBtnName}
                {loader && <span className="loading_icon"></span>}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomSectionAddressAOI;
